import {Picker} from './Dialog'
import Code from './Code'
import utils from '../utils'

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => new Code(String(month).padStart(2, '0') + '月', month))
const baseDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
const normalDays = [...baseDays].map(day => new Code(String(day).padStart(2, '0') + '日', day))
const leapDays = [...baseDays, 29].map(day => new Code(String(day).padStart(2, '0') + '日', day))
const bigDays = [...baseDays, 29, 30, 31].map(day => new Code(String(day).padStart(2, '0') + '日', day))
const smallDays = [...baseDays, 29, 30].map(day => new Code(String(day).padStart(2, '0') + '日', day))
const hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].map(hour => new Code(String(hour).padStart(2, '0') + '时', hour))
const mins = [], secs = []
for(let i = 0; i < 60; i ++){
	mins.push(new Code(String(i + 1).padStart(2, '0') + '分', i + 1))
	secs.push(new Code(String(i + 1).padStart(2, '0') + '秒', i + 1))
}

export default class DatePicker extends Picker{
	constructor(props = {}) {
		super(props)
		this.defaultDate = utils.getDate()
		this.type = 'datePicker'
		this.format = (props.format || 'yy-MM-dd').split('-')
		this.yearRange = (props.yearRange || [this.defaultDate.year]).map(year => new Code(year + '年', year))
	}
	
	init(){
		this.formatValue()
		Object.assign(this, {
			on: {
				change: (picker, values, idx) => {
					const vYear = values[0].code, vMonth = values[1].code, vDay = values[2].code
					if(idx === 0){
						if(Number.parseInt(vMonth) == 2){
							if(vYear % 4 !== 0){
								picker.setColumnValues(2, normalDays)
								if(vDay >= 29){
									picker.setColumnValue(2, '28')
								}
							}else{
								picker.setColumnValues(2, leapDays)
							}
						}
					}else if(idx === 1){
						if(Number.parseInt(vMonth) == 2){
							if(vYear % 4 !== 0){
								picker.setColumnValues(2, normalDays)
								if(vDay >= 29){
									picker.setColumnValue(2, '28')
								}
							}else{
								picker.setColumnValues(2, leapDays)
							}
						}else{
							if([1, 3, 5, 7, 8, 10, 12].includes(Number.parseInt(vMonth))){
								picker.setColumnValues(2, bigDays)
							}else{
								picker.setColumnValues(2, smallDays)
							}
						}
					}
				}
			}
		})
		
		Object.assign(this.props, {
			columns: this.getColumns()
		})
	}
	
	getDays(){
		let days = []
		const [year = '', month = '1', day = '1'] = (this.props.value || '').split(',')
		if(Number.parseInt(month) == 2){
			if(year % 4 === 0){
				days = leapDays
			}else{
				days = normalDays
			}
		}else{
			if([1, 3, 5, 7, 8, 10, 12].includes(Number.parseInt(month))){
				days = bigDays
			}else{
				days = smallDays
			}
		}
		return days
	}
	
	getColumns(){
		const columns = [], days = this.getDays()
		if(this.format.includes('yy')){
			columns.push(this.yearRange)
		}
		if(this.format.includes('MM')){
			columns.push(months)
		}
		if(this.format.includes('dd')){
			columns.push(days)
		}
		if(this.format.includes('hh')){
			columns.push(hours)
		}
		if(this.format.includes('mm')){
			columns.push(mins)
		}
		if(this.format.includes('ss')){
			columns.push(secs)
		}
		console.log(columns, this.format)
		return columns
	}
	
	formatValue(){
		let obj = {}, value = this.props.value
		if(value){
			switch(this.format.join('')){
				case 'yyMMddhhmmss': {
					obj = {
						year: value.split(' ')[0].split('-')[0],
						month: value.split(' ')[0].split('-')[1],
						day: value.split(' ')[0].split('-')[2],
						hour: value.split(' ')[1].split(':')[0],
						min: value.split(' ')[1].split(':')[1],
						sec: value.split(' ')[1].split(':')[2]
					}
					break
				};
				case 'yyMMddhhmm': {
					obj = {
						year: value.split(' ')[0].split('-')[0],
						month: value.split(' ')[0].split('-')[1],
						day: value.split(' ')[0].split('-')[2],
						hour: value.split(' ')[1].split(':')[0],
						min: value.split(' ')[1].split(':')[1]
					}
					break
				};
				case 'yyMMdd': {
					obj = {
						year: value.split(' ')[0].split('-')[0],
						month: value.split(' ')[0].split('-')[1],
						day: value.split(' ')[0].split('-')[2]
					}
					break
				};
				case 'yyMMddhh': {
					obj = {
						year: value.split(' ')[0].split('-')[0],
						month: value.split(' ')[0].split('-')[1],
						day: value.split(' ')[0].split('-')[2],
						hour: value.split(' ')[1].split(':')[0]
					}
					break
				};
				case 'MMdd': {
					obj = {
						month: value.split(' ')[0].split('-')[0],
						day: value.split(' ')[0].split('-')[1]
					}
					break
				};
			}
		}else{
			obj = {}
		}
		this.props.value = Object.values(obj).join(',')
	}
	
	getValue(value){
		value = value.split(',').map(item => String(item).padStart(2, '0'))
		let rs = ''
		switch(this.format.join('')){
			case 'yyMMddhhmmss': {
				const [year, month, day, hour, min, sec] = value
				rs = [year, month, day].join('-') + ' ' + [hour, min, sec].join(':')
				break
			};
			case 'yyMMddhhmm': {
				const [year, month, day, hour, min] = value
				rs = [year, month, day].join('-') + ' ' + [hour, min].join(':')
				break
			};
			case 'yyMMdd': {
				const [year, month, day] = value
				rs = [year, month, day].join('-')
				break
			};
			case 'yyMMddhh': {
				const [year, month, day, hour] = value
				rs = [year, month, day].join('-') + ' ' + hour
				break
			};
			case 'MMdd': {
				const [month, day] = value
				rs = [month, day].join('-')
				break
			};
		}
		return rs
	}
}